/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SessionBookingAmount } from "../../../utilities/api/session";
import { Button } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { CreateCoachingBookingEndUser } from "../../../utilities/api/coachingBooking";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CustomerCoachingBookingStep5 = ({
  data,
  sessionData,
  isStepOneValid,
  isStepTwoValid,
  isStepThreeValid,
}: any) => {
  const { SelectedFacility = "", AllFacilitiesData, errorMessage } = useAppSelector(
    (state) => state.facilityList
  );
  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const selectedFacility = AllFacilitiesData?.find?.(
    (_facility) => _facility?.id == SelectedFacility
  )?.name;
  const navigate = useNavigate();
  const [buttonDisable, setButtonDisable] = useState(false);

  const [totalTax, setTotalTax] = useState(0);
  const [ratePerSession, setRatePerSession] = useState(0);
  const [ratePerWeek, setRatePerWeek] = useState(0);
  const [amount, setAmountData] = useState({}) as any;
  const [offerData, setOfferData] = useState({}) as any;
  useEffect(() => {
    const _ratePerSession = sessionData?.sessionRates?.find?.(
      (_rate: any) => _rate?.noOfDays === data?.noOfDays
    )?.ratePerSession;
    setRatePerSession(_ratePerSession);
    setRatePerWeek(_ratePerSession * data?.noOfDays);
    let offerDataGet: any = {};
    if (sessionData?.sessionOffers?.length) {
      const sortedOffer = sessionData?.sessionOffers?.sort?.(
        (a: any, b: any) => a?.noOfWeeks - b?.noOfWeeks
      );
      sortedOffer?.forEach?.((_offer: any) => {
        if (Number(_offer?.noOfWeeks) <= Number(data?.noOfWeeks)) {
          offerDataGet = _offer;
        }
      });
    }
    setOfferData(offerDataGet);

    let getTotalTax = sessionData?.sessionTaxes?.find?.(
      (_tax: any) => _tax?.tax?.type === "IGST"
    );
    setTotalTax(getTotalTax?.percentage);
    GetAmount();
  }, []);

  const GetAmount = async () => {
    let payload = {
      sessionId: data.sessionId,
      noOfDays: data.noOfDays,
      noOfWeeks: Number(data.noOfWeeks),
      selectedSlots: data.selectedSlots,
      startDate: format(new Date(data?.startDate), "yyyy-MM-dd"),
      isIgstTax: "false",
      discount: data?.discount,
    };
    const result = await SessionBookingAmount(payload);
    if (result.status == 200) {
      let amountData: any = result?.data?.data;
      setAmountData({ ...amountData });
    } else {
      toast.error(result.response.data.message);
    }
  };


  const handleSubmitBooking = async () => {
    if (isStepOneValid() && isStepTwoValid() && isStepThreeValid()) {
      setButtonDisable(true);
      let newData = { ...data };
      delete newData.facilityId;
      delete newData.sportId;
      let _booking = await CreateCoachingBookingEndUser({
        ...newData,
        birthDate: format(new Date(newData?.birthDate), "yyyy-MM-dd"),
        startDate: format(new Date(newData?.startDate), "yyyy-MM-dd"),
      });
      if (_booking.status === 200) {
        if (!_booking.data.data.paymentLink.length)
          navigate(`/coaching-session-booking-detail/${_booking.data.data.id}`);
        else {
          const url = _booking.data.data.paymentLink;
          const link = document.createElement("a");
          link.href = url;
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
        }
      } else {
        toast.error(_booking.response.data.message);
      }
    }
    setButtonDisable(false);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row>
          <h4 className="fs-5 fw-semibold mb-4 text-start">Booking Summary </h4>
          <h5 className="d-block fs-5 fw-semibold mb-4">{sessionData?.name}</h5>
          <hr />
          <Col lg={8}>
            <div className="coach-booking-details">
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Facility Name
                  </span>
                  <span className="user-info">{selectedFacility}</span>
                </Col>
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Court Name
                  </span>
                  <span className="user-info">
                    {sessionData?.sessionCourts?.map(
                      (item: any, index: number) =>
                        index !== sessionData?.sessionCourts?.length - 1
                          ? `${item?.court?.name}, `
                          : item?.court?.name
                    )}
                  </span>
                </Col>
              </Row>
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Sports
                  </span>
                  <span className="user-info">{sessionData?.sport?.name}</span>
                </Col>
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Weekly Session Price
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span> {ratePerWeek}
                  </span>
                </Col>
              </Row>
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Selected Week of Session
                  </span>
                  <span className="user-info">{data?.noOfWeeks}</span>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={4}>
            <table className="table table-bordered table-sm ">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {data?.selectedSlots?.map?.((_slotId: any) => {
                  const _selectedSlot = sessionData?.sessionSlots?.find?.(
                    (_slot: any) => Number(_slot?.id) === Number(_slotId)
                  );
                  return (
                    <tr key={_slotId}>
                      <td>{_selectedSlot?.sessionDay}</td>
                      <td>
                        {_selectedSlot?.startTime} to {_selectedSlot?.endTime}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
        <Row className="text-end">
          <hr />
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Rate Per Session:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {ratePerSession?.toFixed(2) || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Selected Session Per week:{" "}
            </span>
            <span className="user-info"> {data?.noOfDays || 0}</span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Weekly Session Price:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {ratePerWeek?.toFixed(2) || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Weeks Enrolled:{" "}
            </span>
            <span className="user-info"> {data?.noOfWeeks || 0}</span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Offer ({offerData?.discountPercent || 0}%):{" "}
            </span>
            <span className="user-info">
              -<span className="rupees-symbol">&#8377;</span>
              {offerData?.discountPercent > 0
                ? Math.ceil(
                  ratePerWeek *
                  data?.noOfWeeks *
                  (offerData?.discountPercent / 100)
                )
                : 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Sub Total:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {amount?.subTotal?.toFixed(2) || 0}
            </span>
          </Col>

          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Total Tax({totalTax}%):{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {amount?.totalTax?.toFixed(2) || 0}
            </span>
          </Col>

          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Payable Amount:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {Math.round(amount?.totalAmount) || 0}
            </span>
          </Col>
          <Col lg={12}>
            <span className="d-block fst-italic fw-semibold mt-3">
              <sup>*</sup>The Amount is inclusive of all the taxes
            </span>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={12} className="text-end">
            <Button
              disabled={buttonDisable}
              onClick={handleSubmitBooking}
              type="button"
              bname={buttonDisable ? "Proceeding" : "Proceed to Pay"}
              name="pay"
              id="pay"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { CustomerCoachingBookingStep5 };
